import { VenueDetailsComponent } from './venue-details/venue-details.component';
import { VenuesComponent } from './venues.component';
import { Routes } from '@angular/router';

export const venueRoutes: Routes = [
    {
      path: '',
      children: [
        {
          path: ':_venueId',
          component: VenueDetailsComponent,
          loadChildren: () => import('./venue-details/venue-details-routes').then(m => m.venueDetailsRoutes),
        },
        {
           path: '',
           pathMatch: 'full',
           component: VenuesComponent
        },
        {
          path: '**',
          redirectTo: ''
        }
      ],
    },
  ];